import { useQuery } from "@apollo/client";
import { getOrganizationSubjectsGradesAndTagsQuery } from "../modules/Queries";
import _ from "lodash";
import { getOrganizationId } from "modules/CommonSelectors";
import getCurriculumIdsFilterForTags from "Utils/getCurriculumIdsFilterForTags";
import { useReduxState } from "SubjectStandardsV2/hooks/useReduxState";
import { getCurriculumIdAndType } from "SubjectStandardsV2/modules/reduxSelectors";

const EMPTY_ARRAY = [];
const EMPTY_OBJECT = {};

const useFilterQueries = ({ skip = false } = {}) => {
  const orgId = getOrganizationId();
  const { currentCurriculumProgramId: curriculumProgramId } = useReduxState(
    getCurriculumIdAndType
  );

  const { data = EMPTY_OBJECT, networkStatus } = useQuery(
    getOrganizationSubjectsGradesAndTagsQuery,
    {
      fetchPolicy: "cache-and-network",
      variables: {
        orgId,
        curriculumProgramId,
        genericTagsFilter: {
          types: ["GENERIC"],
          ...getCurriculumIdsFilterForTags({ curriculumProgramId }),
        },
      },
      notifyOnNetworkStatusChange: true,
      skip,
    }
  );

  const subjects = data?.node?.subjects || EMPTY_ARRAY;
  const grades = data?.node?.grades || EMPTY_ARRAY;
  const tags = data?.node?.genericTagsV2 || EMPTY_ARRAY;

  return {
    isData: !_.isEmpty(data),
    isLoading: _.includes([1, 2], networkStatus),
    subjects,
    grades,
    tags,
  };
};

export default useFilterQueries;
